import { Random, Vector, vec } from 'excalibur';

export function toRadians(degrees: number): number {
  return (degrees * Math.PI) / 180;
}

export function normalizeDegrees(degrees: number): number {
  return ((degrees % 360) + 360) % 360;
}

export function degreesBetween(a: number, b: number): number {
  const diff = Math.abs(normalizeDegrees(a) - normalizeDegrees(b));
  return diff > 180 ? 360 - diff : diff;
}

export function polarOffset(radius: number, degrees: number): Vector {
  const angle = toRadians(degrees);
  return vec(Math.sin(angle) * radius, -Math.cos(angle) * radius);
}

export function randomAngleAwayFrom(rng: Random, degrees: number, minGap: number): number {
  const span = 360 - minGap * 2;
  return normalizeDegrees(degrees + minGap + rng.floating(0, span));
}

export function easeOutCubic(t: number): number {
  return 1 - Math.pow(1 - t, 3);
}

export function approach(current: number, target: number, rate: number): number {
  if (current < target) {
    return Math.min(target, current + rate);
  }
  return Math.max(target, current - rate);
}
